module.exports = {"TXTCLI_For_detailsX_see_Xa_hrefXXhttp_ELL":{"id":"TXTCLI_For_detailsX_see_Xa_hrefXXhttp_ELL","defaultMessage":"詳しくは<a>{0}</a>をご覧ください。"}}